/* eslint-disable react/prop-types */
import React from 'react';

import DevCard from './DevCard';

function DevConnection({ search }) {
  return (
    <div className="d-flex justify-content-around flex-wrap px-2 mb-5">
      {search
        && search.map(bio => <DevCard key={bio.subjectId} bio={bio} />)}
    </div>
  );
}

export default DevConnection;
